import DocumentationButton from "components/DocumentationButton";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Card from "ds/components/Card";
import EmptyState from "ds/components/EmptyState";
import Tooltip from "ds/components/Tooltip";
import { IconComponent } from "types/Icon";
import { AccessResult } from "utils/access";
import { DocsUrl } from "utils/getDocsUrl";

type NewScanScheduleRequirementEmptyStateProps = {
  icon: IconComponent;
  title: string;
  caption: string;
  primaryActionLabel: string;
  primaryAction: AccessResult;
  onPrimaryAction: () => void;
  onChangeSpace: () => void;
  documentationUrl: DocsUrl;
};

const NewScanScheduleRequirementEmptyState = ({
  icon,
  title,
  caption,
  primaryActionLabel,
  primaryAction,
  onPrimaryAction,
  onChangeSpace,
  documentationUrl,
}: NewScanScheduleRequirementEmptyStateProps) => (
  <Card variant="secondary">
    <EmptyState icon={icon} title={title} caption={caption} padding="large" gap="large">
      <Box gap="large">
        <Tooltip
          active={!!primaryAction.message}
          on={(props) => (
            <Button
              {...props}
              variant="primary"
              disabled={!primaryAction.result}
              onPress={onPrimaryAction}
            >
              {primaryActionLabel}
            </Button>
          )}
        >
          {primaryAction.message}
        </Tooltip>

        <Button variant="secondary" onPress={onChangeSpace}>
          Change space
        </Button>

        <DocumentationButton to={documentationUrl} label="Documentation" />
      </Box>
    </EmptyState>
  </Card>
);

export default NewScanScheduleRequirementEmptyState;
